// Dauber HQ — What's New dismissal.
// Hides the section for the session when dismissed. Resets on new tab/session.

(function () {
  'use strict';

  var STORAGE_KEY = 'dhq-wn-dismissed';
  var section = document.querySelector('[data-whats-new]');

  if (!section) return;

  // Already dismissed this session — remove from DOM before paint
  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    section.remove();
    return;
  }

  // Wire dismiss button
  var btn = section.querySelector('[data-whats-new-dismiss]');
  if (btn) {
    btn.addEventListener('click', function () {
      sessionStorage.setItem(STORAGE_KEY, '1');
      section.remove();
    });
  }
})();
